import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    formHidden: {
      display: 'none'
    },
    formWithOutToolbar: {
      // paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingRight: theme.spacing(2),
      '& .MuiToolbar-gutters': {
        paddingLeft: theme.spacing(0),
        display: 'none'
      },
      '& .DialogContent-dividers': {
        padding: 0
      }
    },
    resultsContainer: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      marginBottom: theme.spacing(2)
    },
    actionsContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: 10
    },
    filters: {
      display: 'flex',
      zIndex: 10
    },
    filter: {
      marginRight: theme.spacing(1),
      marginLeft: '-16px'
    },
    filterDisabled: {
      '& > .MuiChip-label': {
        color: '#999 !important'
      }
    }
  })
